
export class CompozzError extends Error {
	code: number = 0;
	message: string = "";
	error: string = "";
	i18n: string = "";
	params: any[] = [];
	// Optional structured payload describing the error (e.g. a list of items). Params stay scalar values.
	details?: any;

	constructor(code: number, i18n: string, params: any[]) {
		super();
		this.code = code;
		this.i18n = i18n;
		this.params = params;
	}
}

export const isCompozzError = (error: any): error is CompozzError =>
    typeof error === 'object' && error !== null &&
    Object.prototype.hasOwnProperty.call(error, 'code') && typeof error.code === 'number' &&
    Object.prototype.hasOwnProperty.call(error, 'message') && typeof error.message === 'string' &&
    Object.prototype.hasOwnProperty.call(error, 'error') && typeof error.error === 'string';